<template>
  <transition name="modal-fade">
    <div
      class="custom-modal-wrapper"
      v-if="visible"
      @keydown.esc="$emit('close')"
      tabindex="0"
    >
      <div
        class="custom-modal"
        :class="[modalSizeClass, { 'modal-term': term }]"
      >
        <button
          v-if="$listeners.close"
          class="close-btn"
          @click="$emit('close')"
          aria-label="Tutup modal"
        >
          &times;
        </button>

        <div class="custom-modal-body modal-content-center">
          <!-- <img
              :src="require(`@/assets/images/star.png`)"
              alt="Segera Hadir"
              class="modal-star-icon"
            /> -->
          <span class="modal-title"> Segera Hadir </span>
          <div class="modal-description-box">
            <span class="modal-description">
              Fitur ini sedang dalam tahap pengembangan dan akan segera tersedia
              untuk Anda. Terima kasih atas antusiasme Anda!
            </span>
          </div>
          <div class="modal-action-buttons mt-3">
            <button
              class="custom-btn primary"
              @click="$emit('close')"
              ref="closeButton"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalSegeraHadir",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String,
      default: null,
    },
    term: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalSizeClass() {
      if (this.term) return "modal-large";
      switch (this.size) {
        case "small":
          return "modal-small";
        case "large":
          return "modal-large";
        case "xl":
          return "modal-xl";
        default:
          return "modal-default";
      }
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.closeButton) {
            this.$refs.closeButton.focus();
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.custom-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 73, 144, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  padding: 1rem;
}

.custom-modal {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 700px;
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.modal-default {
  max-width: 700px;
}
.modal-small {
  max-width: 400px;
}
.modal-large {
  max-width: 900px;
}
.modal-xl {
  max-width: 1140px;
}
.modal-term {
  min-height: 80vh;
}

.close-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 2rem;
  color: #004990;
  cursor: pointer;
  line-height: 1;
}
.close-btn:hover {
  color: #002f61;
}

.custom-modal-body.modal-content-center {
  text-align: center;
}

.modal-star-icon {
  width: 150px;
}

.modal-title {
  font-weight: 700;
  margin-top: 20px;
  font-size: 26px;
  margin-bottom: 20px;
  color: #f39c12;
}

.modal-description-box {
  background-color: #f9f9f9;
  padding: 15px 20px;
  border-radius: 10px;
  max-width: 400px;
  margin: 0 auto;
}

.modal-description {
  color: #555;
}

.custom-btn.primary {
  background-color: white;
  color: #004990;
  border: 1px solid #004990;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s ease;
}
.custom-btn.primary:hover {
  background-color: #004990;
  color: white;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: all 0.3s ease;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>



// WEBPACK FOOTER //
// src/components/ModalSegeraHadir.vue